import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Form, FormField, Input, Link, Modal, Pagination, Select, SpaceBetween, Table, TextFilter, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";

// Import Froala JS + plugins you need
import FroalaEditorComponent from 'react-froala-wysiwyg';

import Froalaeditor from 'froala-editor';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/table.min.css';
import 'froala-editor/css/plugins/video.min.css';
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/code_beautifier.min.js";
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/quick_insert.min.js";
import "froala-editor/js/plugins/quote.min.js";
import "froala-editor/js/plugins/table.min.js";
import "froala-editor/js/plugins/video.min.js";
const SparkMD5 = require('spark-md5');

import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnWarn, ItemNews } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';
//import SparkMD5 from 'spark-md5';

// Extend the Window interface to include FroalaEditor
declare global {
    interface Window {
        FroalaEditor?: any;
    }
}
export type ItemCategory = {
    idCategory: number;
    hasAltitudes: number;
    thresholdBefore: number;
    thresholdAfter: number;
    category: string;
    label: string;
    value: string;
}
const pageSize = 10;
export const CommNewsListPage = () => {
    //const storeAdmin = useStoreAdmin();


    const { menu } = useGlobalState();
    const [html, setHTML] = React.useState("TEST")
    const [idNews, setIdNews] = React.useState(0)
    const [showEditor, setShowEditor] = React.useState(false)
    const [newsAll, setNewsAll] = React.useState<ItemNews[]>([])
    const [categories, setCategories] = React.useState<ItemCategory[]>([])
    const [category, setCategory] = React.useState<ItemCategory | null>(null);
    const [news, setNews] = React.useState<ItemNews>()
    const [newNews, setNewNews] = React.useState<ItemNews>()



    const { navigate } = useRouter();


    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    //handleList();
                }
                handleGet(id ? parseInt(id) : 0);
            }
            else {
                setNews(undefined);
                handleList();
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    useEffect(() => {
        if (idNews && idNews > 0)
            handleGet(idNews)
    }, [idNews]);
    useEffect(() => {
        //handleList()
    }, []);

    const isNewsSaveDisabled = !!news && (news?.isActiveNews === 1 || news.title === "" || news.idCategory === 0 || news.datePublish === "" || news.timePublish.length !== 5);

    const editorRef = useRef<any>(null);

    const handleList = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/news/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    columns: "idNews, title, subtitle, datePublish, dateCreated,  idCategory, category, isActiveNews",
                    orderBy: "datePublish",
                    order: "desc"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.news) {
                    setNewsAll(data.news)
                    const updatedCategories = data.categories.map((item: { category: any; idCategory: { toString: () => any; }; }) => ({
                        ...item,
                        label: item.category,
                        value: item.idCategory.toString()
                    }))

                    setCategories(updatedCategories)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleGet = async (id: number) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/news/news',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idNews: id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.news)
                    setNews(data.news)

                if (data.categories) {
                    const updatedCategories = data.categories.map((item: { category: any; idCategory: { toString: () => any; }; }) => ({
                        ...item,
                        label: item.category,
                        value: item.idCategory.toString()
                    }))

                    setCategories(updatedCategories)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleUpdate = async (id: number, htmlSource: string) => {
        try {
            setLoading(true);


            const parser = new DOMParser();
            const doc = parser.parseFromString(news.html, 'text/html');

            // 3. Find all <img> elements
            const imgElements = doc.querySelectorAll('img');

            const imageUrls: string[] = Array.from(imgElements)
                .map((img) => img.getAttribute('src'))
                .filter((src): src is string => src !== null && src !== '');

            let body = news;
            body.images = imageUrls;
            body.datePublish = news.datePublish + " " + news.timePublish

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/news/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(news)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                window.location.hash = "#comm/news/list"
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleSave = async () => {
        try {
            setLoading(true);


            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/news/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(newNews)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                window.location.hash = "#comm/news/list?id=" + data.news.idNews
                setNewNews(undefined)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const filtered: ItemNews[] = newsAll.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.title, item.subTitle, item.dateCreated, item.datePublish, item.category, item.idNews.toString()].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);

    useEffect(() => {

        Froalaeditor.DefineIcon('alert', { NAME: 'info', SVG_KEY: 'help' });
        Froalaeditor.RegisterCommand('alert',
            {
                title: 'Hello',
                focus: false,
                undo: false,
                refreshAfterCallback: true,
                callback: function () {
                    this.html.insert(
                        `<div class="article_comment"><p>CONTENT</p><div class="customers">AUTHOR</div></div>`
                    );
                }
            });
    }, []);

    const getFileMD5 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            try {
                const fileReader = new FileReader();

                // 1. Define the success handler
                fileReader.onload = (e) => {
                    console.log("FileReader onload triggered.");
                    try {
                        const buffer = e.target?.result;
                        if (!buffer) {
                            return reject(new Error("Empty file buffer received."));
                        }

                        console.log("FileReader completed. Computing hash...");
                        const spark = new SparkMD5.ArrayBuffer();
                        spark.append(buffer as ArrayBuffer);
                        const hexHash = spark.end();
                        console.log("Computed MD5 hash:", hexHash);
                        resolve(hexHash);

                    } catch (innerError) {
                        reject(innerError);
                    }
                }; // <-- Closes onload cleanly here

                // 2. Define the error handler (Moved OUTSIDE onload)
                fileReader.onerror = (event) => {
                    reject(new Error(`FileReader encountered an operational error: ${fileReader.error?.message || event}`));
                };

                // 3. Kick off the read process (Moved OUTSIDE onload)
                fileReader.readAsArrayBuffer(file);

            } catch (outerError) {
                reject(outerError);
            }
        });
    };



    const froalaConfig = {
        imageUpload: true,
        pastePlain: true,
        useClasses: false,
        imageUploadURL: `${getUrlVersion()}/site/news/image.upload`,
        imageUploadMethod: 'POST',
        imageUploadParam: 'image_param',
        imageAllowedTypes: ['jpeg', 'webp', 'png'],
        imageDefaultAlign: 'right',
        imageDefaultDisplay: 'inline',
        toolbarButtons: [
            "clearFormatting", "alert", "undo", "redo", "quote", "bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "lineHeight", "outdent", "indent", "insertLink", "insertImage", "insertVideo", "insertTable", "insertHR", "selectAll", "html", "help",
        ],
        pluginsEnabled: [
            "paragraphStyle", "image", "codeView", "align", "table", "lists", "link", "clearFormatting", "quote", //"paste"
        ],
        events: {
            'initialized': function (this: any) {
                editorRef.current = this;
                const editorEl = this.el;
                console.log("TEST")

                //editorEl?.addEventListener("paste", handlePaste);
                if (editorEl) {
                    console.log("TEST")
                    if (!editorEl.querySelector('style[data-article-comment]')) {
                        console.log("TEST")
                        const styleEl = document.createElement("style");
                        styleEl.setAttribute("data-article-comment", "true");
                        styleEl.innerHTML = `
                        .article_comment {
                            border: 1px solid #007bff;
                            padding: 10px;
                            margin 10px;
                            background-color: #f0f8ff;
                        }
                        .article_comment p {
                            margin: 0 0 5px 0;
                            font-weight: bold;
                            border: 1px #000 dashed;
                        }
                        .article_comment .customers {
                            font-style: italic;
                            border: 1px #000 dashed;
                            color: #555;
                        }
                        `;
                        editorEl.appendChild(styleEl);
                    }
                }
            },
            'image.removed': function (this: any, img: any) {
                if (img && img.length === 1) {
                    try {
                        const srcUrl = img[0].src;

                        if (srcUrl && !srcUrl.startsWith('data:image')) {
                            const cleanUrl = srcUrl.split('?')[0];
                            const filename = cleanUrl.split('/').pop();

                            fetch(`${getUrlVersion()}/routing/v1/`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-routing': '/private/admin/news/image.delete',
                                    'JWT': getCookie("JWT"),
                                    //  
                                },
                                body: JSON.stringify({ file: filename })
                            })
                                .then((res) => {
                                    if (!res.ok) throw new Error(`Deletion status failed: ${res.status}`);
                                    return res.json();
                                })
                                .then((data) => {
                                    console.log("Asset successfully unlinked and deleted from S3:", data);
                                })
                                .catch((err) => {
                                    console.error("Backend S3 orchestration teardown failed:", err);
                                });
                        }
                    } catch (error) {
                        console.error("Error while attempting to delete S3 asset:", error);
                    }
                }
            },
            'image.beforeUpload': function (images: any) {
                console.log("Native automatic upload blocked.");
                return false; // Crucial: Cancels Froala's native duplicate upload thread
            },
            'paste.before': function (this: any, event: ClipboardEvent) {
                const clipboardData = event.clipboardData;
                if (!clipboardData) {
                    return true; // nothing to inspect, let Froala do its default thing
                }

                const imageFiles = Array.from(clipboardData.items || [])
                    .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
                    .map((item) => item.getAsFile())
                    .filter((file): file is File => file !== null);

                if (imageFiles.length === 0) {
                    console.log("plain text/html paste, no image")
                    return true; // plain text/html paste, no image — let Froala handle it normally
                }

                const editor = this;
                imageFiles.forEach((file) => {
                    console.log("Passing to getFileMD5:", file);
                    const convertToBase64 = (fileToConvert: any) => {
                        return new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(fileToConvert);
                            reader.onload = () => {
                                const result = reader.result;
                                if (typeof result === 'string') {
                                    // Split and take only the raw base64 string part
                                    const base64String = result.split(',')[1];
                                    resolve(base64String);
                                } else {
                                    reject(new Error("Expected string from FileReader"));
                                }
                            };
                            reader.onerror = (error) => reject(error);
                        });
                    };

                    // 2. Run both getFileMD5 and base64 conversion in parallel for efficiency
                    Promise.all([getFileMD5(file), convertToBase64(file)])

                        .then(([fileId, base64file]) => {
                            const id = `${news.idNews}-${fileId}`;


                            return fetch(`${getUrlVersion()}/routing/v1/`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-routing': '/private/admin/news/image.upload',
                                    'JWT': getCookie("JWT"),
                                    //  
                                },
                                body: JSON.stringify({ id: id, base64file: base64file })
                            });
                        })
                        .then((res) => res.json())
                        .then((data) => {
                            if (data?.link && editorRef.current) {
                                console.log('Inserting image with link:', data.link);
                                editorRef.current.image.insert(
                                    data.link,
                                    false,
                                    null,
                                    editorRef.current.image.get()
                                );
                            }
                        })
                        .catch((err) => console.error('Paste upload failed:', err));
                });
                console.log("Finished processing pasted images.");

                // Block Froala's default paste handling entirely for this event,
                // so it never also processes the HTML <img data:...> representation.
                return false;
            },

            // Optional: if a user drags/inserts an image through the toolbar (not paste),
            // this still goes through Froala's normal single-channel upload, so no changes needed there.
            'image.error': function (this: any, error: any, response: any) {
                console.error('Froala image upload failed:', error, response);
            }
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}

            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                < SpaceBetween size="s" direction='vertical' >
                    {/*<Button onClick={()=>{setCookie("JWT", "")}}>COOKIE</Button>*/}
                    <Header actions={
                        <>
                            {!!news && (<Button onClick={() => window.location.href = "#comm/news/list"}>Listado</Button>)}
                            {!news && (<Button onClick={() =>
                                setNewNews({ idNews: 0, title: "", html: "", idCategory: 0 } as ItemNews)
                            }>Agregar</Button>)}
                            <Favorites />
                        </>}
                        variant="h1" >Noticias </Header>
                    {!news && (

                        <Table
                            variant="embedded"

                            filter={filtered ? (
                                <TextFilter
                                    filteringPlaceholder="Filtrar"
                                    filteringText={filterValue}
                                    onChange={({ detail }) => {
                                        setFilterValue(detail.filteringText);
                                        setCurrentPageIndex(1);
                                    }}
                                />
                            ) : undefined}
                            pagination={
                                filtered.length > pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )
                            }
                            columnDefinitions={[
                                {
                                    id: "idNews",
                                    header: "ID",
                                    cell: item => <Link href={`#comm/news/list?id=${item.idNews}`}>{item.idNews}</Link>,
                                },
                                {
                                    id: "category",
                                    header: "Categoría",
                                    cell: item => item.category,
                                },
                                {
                                    id: "date",
                                    header: "Fecha/Publicación",
                                    cell: item => item.dateCreated,
                                },
                                {
                                    id: "title",
                                    header: "Título",
                                    cell: item => (
                                        <div style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "350px"   // adjust as needed
                                        }}>
                                            {item.title}
                                        </div>
                                    )
                                },
                            ]}
                            items={paginated ?? []}
                        />
                    )}
                    {!!news && (
                        <>
                            <Form
                                secondaryActions={
                                    <Button onClick={() => setShowEditor(false)} variant="link">Cancelar</Button>
                                }
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button
                                            disabled={news.isActiveNews === 1}
                                            disabledReason="No se puede eliminar una noticia activa"
                                            style={{ root: btnWarn }} onClick={() => {

                                            }}>Eliminar</Button>
                                        <Button variant="primary"
                                            disabled={isNewsSaveDisabled}
                                            onClick={() => {

                                                const html = news.html;

                                                let html2 = html.replace(
                                                    /<p[^>]*data-f-id="pbf"[^>]*>.*?<\/p>/gi,
                                                    ""
                                                );



                                                const wrapper = document.createElement("div");
                                                wrapper.innerHTML = html2;

                                                // 1️⃣ Remove <style data-article-comment> added for the editor
                                                wrapper.querySelectorAll('style[data-article-comment]').forEach(styleEl => styleEl.remove());

                                                // 2️⃣ Fix article_comment blocks
                                                const articleBlocks = wrapper.querySelectorAll('[fr-original-class="article_comment"]');

                                                articleBlocks.forEach(block => {
                                                    // Restore class
                                                    block.classList.add("article_comment");

                                                    // Remove Froala helper attributes
                                                    block.removeAttribute("fr-original-class");
                                                    block.removeAttribute("fr-original-style");

                                                    // Remove inline styles from the block itself
                                                    block.removeAttribute("style");

                                                    // Remove inline styles from children
                                                    block.querySelectorAll("*").forEach(child => child.removeAttribute("style"));
                                                });

                                                // 3️⃣ Optional: Also fix .customers inside article_comment
                                                const customerBlocks = wrapper.querySelectorAll('[fr-original-class="customers"]');
                                                customerBlocks.forEach(block => {
                                                    block.classList.add("customers");
                                                    block.removeAttribute("fr-original-class");
                                                    block.removeAttribute("fr-original-style");
                                                    block.removeAttribute("style");
                                                });


                                                news.html = wrapper.innerHTML;

                                                handleUpdate(news?.idNews, html);
                                            }}>Guardar</Button>
                                    </SpaceBetween>
                                }
                            >
                                <FormField label="Titulo">
                                    <Input value={news?.title || ""} onChange={(event) => setNews({ ...news, title: event.detail.value })} />
                                </FormField>

                                <FormField label="Sub titulo">
                                    <Input value={news?.subTitle || ""} onChange={(event) => setNews({ ...news, subTitle: event.detail.value })} />
                                </FormField>


                                <FormField label="Categoría">
                                    <Select
                                        selectedOption={categories.find(cat => cat.idCategory === news?.idCategory)}
                                        onChange={({ detail }) => {
                                            setNews({ ...news, idCategory: Number(detail.selectedOption.value) })

                                        }}
                                        options={categories}
                                        placeholder="Seleccione una categoría"
                                    />
                                </FormField>


                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField label="Fecha creación">
                                        <DPModal date={news?.dateCreated || ""}
                                            width={120}
                                            readonly
                                        />
                                    </FormField>
                                    <FormField label="Hora creación">
                                        <div style={{ width: 80 }}>
                                            <TimeInput
                                                readOnly
                                                format="hh:mm"
                                                placeholder='00:00'
                                                value={news?.timeCreated || ""} />
                                        </div>
                                    </FormField>
                                    <FormField label="Fecha publicación">
                                        <DPModal date={news?.datePublish || ""}
                                            width={120}
                                            onConfirm={(date: string) => setNews({ ...news, datePublish: date })}
                                        />
                                    </FormField>
                                    <FormField label="Hora publicación">
                                        <div style={{ width: 80 }}>
                                            <TimeInput
                                                autoComplete={false}
                                                onChange={(event) =>
                                                    setNews((prev) => ({
                                                        ...prev!,
                                                        timePublish: event.detail.value
                                                    }))}
                                                format="hh:mm"
                                                placeholder='00:00'
                                                value={news?.timePublish || ""} />
                                        </div>
                                    </FormField>
                                </SpaceBetween>

                                <div style={{ marginTop: 15 }}>
                                    <FroalaEditorComponent tag="textarea" config={froalaConfig}

                                        onModelChange=
                                        {(model: any) => setNews({ ...news, html: model })}
                                        model={news?.html || ""}
                                    />

                                </div>
                            </Form>
                        </>
                    )}
                    {!!newNews && (
                        <Modal visible={!!newNews} onDismiss={() => setNewNews(undefined)}
                            header="Nueva Noticia"

                        >
                            <Form
                                secondaryActions={
                                    <Button variant="link" onClick={() => {
                                        setNewNews(undefined);
                                    }}>Cancelar</Button>
                                }
                                actions={
                                    <Button
                                        disabled={newNews.title.length < 10 || newNews.idCategory === 0}
                                        variant="primary" onClick={() => {
                                            handleSave();
                                        }}>Agregar</Button>
                                }>
                                <SpaceBetween direction="vertical" size="xs">
                                    <FormField label="Título">
                                        <Input value={newNews?.title || ""} onChange={(event) => {
                                            setNewNews({ ...newNews, title: event.detail.value });
                                        }} />
                                    </FormField>

                                    <SpaceBetween direction="horizontal" size="xs">
                                        <FormField label="Categoría">

                                            <Select
                                                selectedOption={categories.find(category => category.value === String(newNews?.idCategory))}
                                                onChange={({ detail }) => {
                                                    setNewNews({ ...newNews, idCategory: Number(detail.selectedOption.value) })

                                                }}
                                                options={categories}
                                                placeholder="Seleccione una categoría"
                                            />
                                        </FormField>
                                    </SpaceBetween>
                                </SpaceBetween>
                            </Form>
                        </Modal>
                    )}

                </SpaceBetween >
            }
        />
    );
};


async function getFileMD5(file: any) {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('MD5', buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}